module.exports = "/packs/iphone-9a224c7ab0ee6317837e878afd05a436.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/packs/Shared/assets/images/iphone.png
// module id = ./app/javascript/packs/Shared/assets/images/iphone.png
// module chunks = 1